// src/constants/statusColors.ts

/**
 * 🔄 신청서 전체 상태별 색상 정의 (업데이트됨)
 * 모든 대시보드/관리자 UI에서 import하여 통일성 유지
 */
export const APPLICATION_STATUS_COLORS: Record<string, string> = {
  전체: '#90a4ae',        // Neutral gray
  접수완료: '#1976d2',     // Blue (진행 시작)
  택배접수: '#29b6f6',     // Sky blue (택배)
  입고완료: '#00bcd4',     // Cyan (입고완료/도착)
  검수중: '#7e57c2',      // Purple (검수/작업중)
  가격안내: '#ffb300',     // Yellow (견적/알림)
  입금대기: '#26a69a',    // Teal (입금대기)
  부분완료: '#ff9800',    // Orange (부분 처리/혼재)
  반송: '#ef5350',        // Red (반송)
  완료: '#43a047',        // Green (성공/완료)
};

/**
 * 🔄 개별 기기 상태별 색상 정의 (사용자 요구사항에 맞는 8개 상태)
 */
export const DEVICE_STATUS_COLORS: Record<string, string> = {
  접수완료: '#1976d2',     // Blue (접수 완료)
  택배접수: '#29b6f6',     // Sky blue (택배 접수)
  입고완료: '#00bcd4',     // Cyan (입고 완료)
  검수중: '#7e57c2',      // Purple (검수 진행)
  가격안내: '#ffb300',     // Yellow (가격 제안)
  입금대기: '#26a69a',     // Teal (사용자 수락)
  반송: '#ef5350',        // Red (반송 요청)
  완료: '#43a047',        // Green (입금 완료)
};

/**
 * 🔄 하위 호환성을 위한 기존 export (deprecated)
 */
/** @deprecated APPLICATION_STATUS_COLORS를 사용하세요 */
const STATUS_COLORS: Record<string, string> = {
  ...APPLICATION_STATUS_COLORS,
  // 기존 상태들도 매핑 (하위 호환성)
  신청완료: APPLICATION_STATUS_COLORS.접수완료,
  반송완료: APPLICATION_STATUS_COLORS.반송,
  '매입 불가': APPLICATION_STATUS_COLORS.반송,
  취소: APPLICATION_STATUS_COLORS.반송,
  // 기기 상태 하위 호환성 매핑
  수락됨: '#26a69a',
  반송됨: '#ef5350',
  입금완료: '#43a047',
};

export default STATUS_COLORS;

/**
 * 🔧 상태별 색상 조회 헬퍼 함수
 */
export const getApplicationStatusColor = (status: string): string => {
  return APPLICATION_STATUS_COLORS[status] || '#90a4ae';
};

export const getDeviceStatusColor = (status: string): string => {
  return DEVICE_STATUS_COLORS[status] || '#90a4ae';
};
